var escape = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.share-box[data-v-3e469a64] {\n  position: absolute;\n  width: 0.68rem;\n  height: 0.68rem;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  background-image: url(" + escape(require("../../../assets/hznz-img/share-icon.png")) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 50%;\n}\n", ""]);

// exports
